import { Alert, AlertProps, CustomFlowbiteTheme } from 'flowbite-react'
import React, { FC, SVGProps } from 'react'

const customAlertTheme: CustomFlowbiteTheme['alert'] = {
  closeButton: {
    color: {
      orange:
        'bg-orange-50 text-orange-800 hover:bg-orange-200 focus:ring-orange-400 dark:bg-orange-200 dark:text-orange-600 dark:hover:bg-orange-300',
    },
  },
  color: {
    orange:
      'border-orange-500 bg-orange-50 text-orange-800 dark:bg-orange-200 dark:text-orange-800',
  },
}

interface AppAlertProps extends Omit<AlertProps, 'icon'> {
  icon?: FC<Omit<SVGProps<SVGSVGElement>, 'ref'>>
}

const AppAlert: React.FC<AppAlertProps> = ({ icon, children, ...props }) => (
  <Alert {...props} icon={icon} theme={customAlertTheme}>
    {children}
  </Alert>
)
export default AppAlert
